module.exports = __webpack_public_path__ + "img/appstore.3470cca8.svg";